import SmCrypto from 'sm-crypto'
import JsMd5 from 'js-md5'
import CryptoJs from 'crypto-js'
const PRIVATE_KEY = '255cdf98d4ffcbcdbfc02bff3baa94e8bc274a29395a1e8646c5fcb5a8a32d83'
const PUBLIC_KEY = '0454ee9070fb3e7e50c929ac3264aab3e55e880efb4086cb521949b6d80fae2dd32161dcf15d1a4d34c0b9f485ddaea1c4deb8b11027242f0370da9f7be159e6ee'
const SM4_KEY = 'fd2a0d71dc7111668a3f5282695e6bde'

/**
 * SM2签名C1C2C3
 * */
let sm2Sign123 = content => {
  return sm2Sign(content, 0)
}

/**
 * SM2验签C1C2C3
 * */
let sm2Check123 = (content, sign) => {
  return sm2Check(content, sign, 0)
}

/**
 * SM2签名C1C3C2
 * */
let sm2Sign132 = content => {
  return sm2Sign(content, 1)
}

/**
 * SM2验签C1C3C2
 * */
let sm2Check132 = (content, sign) => {
  return sm2Check(content, sign, 1)
}

/**
 * SM2加密C1C2C3
 * */
let sm2Encrypt123 = (content, publicKey) => {
  return sm2Encrypt(content, 0, publicKey)
}

/**
 * SM2解密C1C2C3
 * */
let sm2Decrypt123 = (content, privateKey) => {
  return sm2Decrypt(content, 0, privateKey)
}

/**
 * SM2加密C1C3C2
 * */
let sm2Encrypt132 = (content, publicKey) => {
  return sm2Encrypt(content, 1, publicKey)
}

/**
 * SM2解密C1C3C2
 * */
let sm2Decrypt132 = (content, privateKey) => {
  return sm2Decrypt(content, 1, privateKey)
}

/**
 * SM3加密
 * */
let sm3Encrypt = content => {
  if (!content || content === null) return null
  const sm3 = SmCrypto.sm3
  return sm3(md5(content))
}

/**
 * SM4加密
 * */
let sm4JsEncrypt = (content, sm4Key) => {
  if (!content || content === null) return null
  const sm4 = SmCrypto.sm4
  return sm4.encrypt(content, sm4Key === undefined || sm4Key === null || sm4Key === '' ? SM4_KEY : sm4Key)
}

/**
 * SM4解密
 * */
let sm4JsDecrypt = (content, sm4Key) => {
  if (!content || content === null) return null
  const sm4 = SmCrypto.sm4
  const sm4Decrypt = sm4.decrypt(content, sm4Key === undefined || sm4Key === null || sm4Key === '' ? SM4_KEY : sm4Key)
  if (!sm4Decrypt) return content
  return sm4Decrypt
}

/**
 * md5加密
 * */
let md5 = content => {
  if (!content || content === null) return null
  return JsMd5(content)
}

/**
 * des加密
 * */
let desEncrypt = (key, content) => {
  if (!key || key === null || !content || content === null) return null
  return CryptoJs.DES.encrypt(content, CryptoJs.enc.Utf8.parse(key), { mode: CryptoJs.mode.ECB, padding: CryptoJs.pad.Pkcs7 }).ciphertext.toString()
}

/**
 * des解密
 * */
let desDecrypt = (key, content) => {
  if (!key || key === null || !content || content === null) return null
  return CryptoJs.DES.decrypt({ ciphertext: CryptoJs.enc.Hex.parse(content) }, CryptoJs.enc.Utf8.parse(key), { mode: CryptoJs.mode.ECB, padding: CryptoJs.pad.Pkcs7 }).toString(CryptoJs.enc.Utf8)
}

export default { sm2Sign123, sm2Encrypt123, sm2Decrypt123, sm2Check123, sm2Sign132, sm2Encrypt132, sm2Decrypt132, sm2Check132, sm3Encrypt, sm4JsEncrypt, sm4JsDecrypt, md5, desEncrypt, desDecrypt }

/**
 * SM2签名
 * */
let sm2Sign = (content, type) => {
  if (!content || content === null) return null
  return sm2Encrypt(sm3Encrypt(content), type)
}

/**
 * SM2加密
 * */
let sm2Encrypt = (content, type, publicKey) => {
  if (!content || content === null) return null
  const sm2 = SmCrypto.sm2
  return '04' + sm2.doEncrypt(content, publicKey === undefined || publicKey === null || publicKey === '' ? PUBLIC_KEY : publicKey, type)
}

/**
 * SM2解密
 * */
let sm2Decrypt = (content, type, privateKey) => {
  if (!content || content === null) return null
  if (content.indexOf('04') === 0) content = content.slice(2)
  const sm2 = SmCrypto.sm2
  const sm2Decrypt = sm2.doDecrypt(content, privateKey === undefined || privateKey === null || privateKey === '' ? PRIVATE_KEY : privateKey, type)
  if (!sm2Decrypt) return content
  return sm2Decrypt
}

/**
 * SM2验签
 * */
let sm2Check = (content, sign, type) => {
  if (!content || content === null || !sign || sign === null) return false
  return sm3Encrypt(content) === sm2Decrypt(sign, type)
}
